var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoicongray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.68745 6.49995H7.18744V10.9999H7.68744M13.6874 7.49994C13.6874 9.22383 13.0026 10.8771 11.7836 12.0961C10.5646 13.3151 8.91133 13.9999 7.18744 13.9999C5.46355 13.9999 3.81026 13.3151 2.59129 12.0961C1.37231 10.8771 0.6875 9.22383 0.6875 7.49994C0.6875 5.77605 1.37231 4.12276 2.59129 2.90379C3.81026 1.68481 5.46355 1 7.18744 1C8.91133 1 10.5646 1.68481 11.7836 2.90379C13.0026 4.12276 13.6874 5.77605 13.6874 7.49994Z",
    stroke: "#8C8C8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68749 4.25C7.68749 4.3826 7.63481 4.50978 7.54105 4.60355C7.44728 4.69731 7.3201 4.74999 7.1875 4.74999C7.05489 4.74999 6.92771 4.69731 6.83395 4.60355C6.74018 4.50978 6.6875 4.3826 6.6875 4.25C6.6875 4.11739 6.74018 3.99021 6.83395 3.89645C6.92771 3.80268 7.05489 3.75 7.1875 3.75C7.3201 3.75 7.44728 3.80268 7.54105 3.89645C7.63481 3.99021 7.68749 4.11739 7.68749 4.25Z",
    fill: "#8C8C8C",
    stroke: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoicongray);
export default __webpack_public_path__ + "static/media/infoicongray.06872806177ebea532f485003aa2147e.svg";
export { ForwardRef as ReactComponent };